import React from "react";
import PageHero from "../components/PageHero";
import SEO from "../components/SEO";
import { assets } from "../data/siteData";

export default function ChlorinationPage() {
  return (
    <>
      <SEO
        title="Water Chlorination & Bacteria Removal Systems in Kolkata, West Bengal"
        description="Hydrotec Solutions provides chlorination systems for bacteria removal, water disinfection, and safe drinking water management in Kolkata, Newtown, Rajarhat, and West Bengal. Controlled dosing for homes, institutions, and industrial sites."
        keywords="water chlorination Kolkata, bacteria removal water Kolkata, water disinfection Newtown, chlorination system Rajarhat, remove bacteria from water West Bengal, water safety Kolkata, chlorine dosing West Bengal"
        canonical="https://hydroteclimited.com/solutions/chlorination"
      />
      <PageHero
        title="Chlorination Systems"
        text="Chlorination treatment and reuse systems..."
        image={assets.chlorinationPlant}
      />

      <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-2">
          <div>
            <h2 className="text-3xl font-bold text-slate-900">
              Precise dosing systems for dependable disinfection control
            </h2>
            <p className="mt-5 leading-8 text-slate-600">
              Hydrotec chlorination systems are designed to support effective
              disinfection through controlled dosing, system integration, and
              safer treatment operations across water infrastructure setups.
            </p>
            <p className="mt-4 leading-8 text-slate-600">
              These systems can be used as part of a larger treatment plant,
              kiosk infrastructure, storage-based water system, or process water
              quality management solution. We deploy chlorination and bacteria
              removal systems across Kolkata, Newtown, Rajarhat, and West Bengal.
            </p>
            <a
              href="https://aquahome.hydroteclimited.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-block font-semibold text-blue-600"
            >
              Learn more about our chlorination systems →
            </a>
          </div>

          <div className="rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
            <h3 className="text-xl font-semibold text-slate-900">Key Benefits</h3>
            <ul className="mt-5 space-y-3 text-slate-600">
              <li>• Controlled disinfectant dosing</li>
              <li>• Improved water safety support</li>
              <li>• Integration with treatment and storage systems</li>
              <li>• Suitable for automated operation</li>
              <li>• Compact and practical installation layout</li>
              <li>• Monitoring-ready performance configuration</li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}